import FirmLogo from './FirmLogo-redux';

export default FirmLogo;
